var Marionette = require('marionette')
var OptionsCollectionView = require('./../ItemOptionsCollection')
var tplSurveyItem = require('./../../templates/Item.html')

module.exports = Marionette.LayoutView.extend({
  tagName: 'li',
  regions: {
    optionsContainer: '.survey-item__options'
  },
  template: tplSurveyItem,
  className: 'survey-item survey-item--multiselect',
  getValues: function () {
    return this.model
      .get('options')
      .filter(function (option) {
        return option.get('selected')
      })
      .map(function (option) {
        return option.get('value')
      })
  },
  valueChanged: function () {
    this.trigger(
      'item:value:changed',
      this.getOption('itemIndex'),
      this.getValues()
    )
  },
  onRender: function () {
    var _OptionsCollectionView = new OptionsCollectionView({
      itemIndex: this.getOption('itemIndex'),
      collection: this.model.get('options')
    })

    this.listenTo(
      _OptionsCollectionView,
      'item:value:changed',
      this.valueChanged.bind(this)
    )
    this.getRegion('optionsContainer').show(_OptionsCollectionView)
  }
})
